import React, { Fragment } from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";
import NoData from "./NoData";

const HotelTableData = ({ data }) => {
  const styles = StyleSheet.create({
    Hotelcontainer: {
      flexDirection: "row",
      alignItems: "center",
      fontStyle: "bold",
      paddingBottom: "5px",
      paddingTop: "10px",
      paddingLeft: "15px",
      border: "1px solid #E4E4E4",
      borderRadius: "5px",
      width: "100%",
      marginTop: "5px",
    },
    Location: {
      width: "20%",
      fontSize: "11px",
      color: "#333333",
    },
    form: {
      width: "15%",
      fontSize: "11px",
      color: "#333333",
    },
    to: {
      width: "15%",
      fontSize: "11px",
      color: "#333333",
    },
    description: {
      width: "25%",
      fontSize: "11px",
      color: "#333333",
    },
  });
  return (
    <Fragment>
      {data && data?.hotel_reservations?.length > 0 ? (
        data?.hotel_reservations?.map((items) => (
          <View style={styles.Hotelcontainer}>
            <Text style={styles.Location}>
              {items?.location ? items?.location : "-"}
            </Text>
            <Text style={styles.form}>
              {items?.duration_from ? items?.duration_from : "-"}
            </Text>
            <Text style={styles.to}>
              {items?.duration_to ? items?.duration_to : "-"}
            </Text>
            <Text style={styles.description}>
              {items?.description ? items?.description : "-"}
            </Text>
          </View>
        ))
      ) : (
        <NoData title="Hotel Data" />
      )}
    </Fragment>
  );
};

export default HotelTableData;
